import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class RegexService {

  constructor(private regex: HttpClient) {};

  omit_special_characters_except_AMPERSAND(event: KeyboardEvent) {
    return event.key === '-' || event.key === '&' || /^[A-Za-z0-9]*$/.test(event.key) ? true : false;
  };

  omit_just_spaces(event: KeyboardEvent) {
    return event.key === '-' || /^[A-Za-z0-9]*$/.test(event.key) ? true : false;
  };

  allExceptSpaces(event: KeyboardEvent) {
    return !(/^\s*$/.test(event.key));
  };

  // REFERENCIA METHODS


  REFERENCIA_PASTE_REMOVE_SPACES_START_MIDDLE_END(event: ClipboardEvent, form: FormGroup) {
    
    let textWithoutSpaces = event.clipboardData?.getData('text/plain').trim().replace(/\s/g, '');

    form.patchValue({
      referencia: textWithoutSpaces,
    });
  
    event.preventDefault();
  };

  // RFC METHODS

  RFC_PASTE_JUST_AMPERSAND_LETTERS_NUMBERS(event: ClipboardEvent, form: FormGroup) {
            
    let textWithoutSpaces = event.clipboardData?.getData('text/plain').trim().replace(/[^a-zA-Z0-9&]/g, '');

    form.patchValue({
      rfcReceptor: textWithoutSpaces,
    });
  
    event.preventDefault();
    
  };

  // FOLIO PARA OPERA

  OPERA_FOLIO_JUST_AND_JUST_NUMBERS(event: ClipboardEvent, form: FormGroup) {
            
    let filterRegexData = event.clipboardData?.getData('text/plain').trim().replace(/[^0-9]/g, '');


    form.patchValue({
      folio: filterRegexData?.slice(0, 7),
    });
  
    event.preventDefault();
    
  };

  // BILL FORM METHODS

    RFC_PASTE_BILLFORM_JUST_AMPERSAND_LETTERS_NUMBERS(event: ClipboardEvent, form: FormGroup) {
            
    let textWithoutSpaces = event.clipboardData?.getData('text/plain').trim().replace(/[^a-zA-Z0-9&]/g, '');

    form.patchValue({
      rfc: textWithoutSpaces,
    });
  
    event.preventDefault();
    
  };

  public CP_BILLFORM_JUST_NUMBERS(event: ClipboardEvent, form: FormGroup) {

    let textWithoutSpaces = event.clipboardData?.getData('text/plain').trim().replace(/[^0-9]/g, '');

    form.patchValue({
      domicilioFiscal: textWithoutSpaces?.slice(0, 5),
    });
  
    event.preventDefault();
  };

  public NOMBRE_RAZON_SOCIAL_REMOVE_ALL_SPACES(event: ClipboardEvent, form: FormGroup) {
            
    let textWithoutSpaces = event.clipboardData?.getData('text/plain').trim();

    form.patchValue({
      nombre: textWithoutSpaces?.toUpperCase(),
    });
  
    event.preventDefault();
    
  };

  public EMAIL_REMOVE_ALL_SPACES(event: ClipboardEvent, form: FormGroup) {
            
    let textWithoutSpaces = event.clipboardData?.getData('text/plain').trim();

    form.patchValue({
      email: textWithoutSpaces,
    });
  
    event.preventDefault();
    
  };



};
